import React from "react";
import { Props } from "./types";

function SelectedIcon(props: Props) {
  return (
    <svg className={props.className} viewBox="0 0 18.978 13.639">
      <path
        data-name="Tracé 5562"
        d="M117.624,147.464a2.388,2.388,0,0,0-3.343-.119l-7.641,7.282-3.223-3.343a2.388,2.388,0,0,0-3.343-.119,2.507,2.507,0,0,0,0,3.462l4.895,5.014a2.148,2.148,0,0,0,1.671.716,2.387,2.387,0,0,0,1.671-.716l9.312-8.834a2.268,2.268,0,0,0,.138-3.2C117.718,147.554,117.672,147.508,117.624,147.464Z"
        transform="translate(-99.381 -146.719)"
      />
    </svg>
  );
}

export { SelectedIcon };
